<div class="app_bar_reuniones">
    <!-- Toolbar -->
    <mat-toolbar class="toolbar_reuniones">
        <span></span>
        <h5 class="info_text">
            {{ "#estudiantes" }}
            <span class="alumn_text"> reuniones</span>
        </h5>
        <span class="phone_span"></span>
        <!-- Button Search/filtro  -->
        <div class="phone_buscar">
            <button mat-button color="primary" (click)="drawer.toggle()">
                <span class="flex_button">
                    <mat-icon>search</mat-icon>
                    <span class="text_buscar">buscar</span>
                </span>
            </button>
        </div>
    </mat-toolbar>

    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>

    <mat-sidenav-container style="height: calc(100% - 64px);" autosize>
        <mat-sidenav-container style="height: 100%;" class="state_cero">
            <mat-sidenav #drawer class="sidenav" attr.role="navigation" mode="'over'" position="end">
                <!-- Button Close -->
                <mat-toolbar>
                    <button mat-mini-fab color="primary" (click)="drawer.close()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-toolbar>
                <!-- Filtros Phone -->
                <div class="filtros_phone">
                    <app-filtro-curso></app-filtro-curso>
                    <app-filtro-estado [label]="'Estudiantes'"></app-filtro-estado>
                </div>
            </mat-sidenav>

            <!-- Filtros PC-->
            <mat-card class="card-filtros">
                <mat-card-subtitle>
                    <div class="filtros_flex">
                        <app-filtro-curso></app-filtro-curso>
                        <app-filtro-estado [label]="'Estudiantes'"></app-filtro-estado>
                    </div>
                </mat-card-subtitle>
            </mat-card>
            <!-- IMG fondo-->
            <!-- <div class="state_imagen">
                <img class="image_vector"
                    src="https://w3miglm.blob.core.windows.net/com/wwwInternals/Logo%20GLM/miglm_vector.webp">
                <h4 class="text_state">Agregue una reunión con el botón</h4>
            </div> -->
            <!-- Card Reunion -->
            
                <app-notas-tabla></app-notas-tabla>
          
        </mat-sidenav-container>
    </mat-sidenav-container>
</div>